import { render, staticRenderFns } from "./AdminCertificateDataManage.vue?vue&type=template&id=4b45a6a7&scoped=true"
import script from "./AdminCertificateDataManage.vue?vue&type=script&lang=js"
export * from "./AdminCertificateDataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45a6a7",
  null
  
)

export default component.exports